module.exports = __webpack_public_path__ + "img/ps.66f425e1.svg";